import { apiGet, apiPatch } from './client';
import type { IdxRate, IdxRateBatchRequest } from '../types/IdxRate';

export function getIdxRates(): Promise<IdxRate[]> {
  return apiGet<IdxRate[]>('/api/idx-rates');
}

export function saveIdxRatesBatch(
  added: IdxRate[],
  modified: IdxRate[],
  deletedIds: number[],
): Promise<IdxRate[]> {
  return apiPatch<IdxRateBatchRequest, IdxRate[]>('/api/idx-rates/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
